export const FLEET_ROLE_OPTIONS = [
  { value: 'fleet_manager', label: 'Fleet Manager' },
  { value: 'fleet_inspector', label: 'Inspector' },
];

export function fleetRoles(record) {
  if (Array.isArray(record?.roles)) return record.roles;
  return [record?.accessLevel === 'inspector' || record?.role === 'fleet_inspector'
    ? 'fleet_inspector' : 'fleet_manager'];
}

export function fleetRolesLabel(record) {
  return FLEET_ROLE_OPTIONS.filter(({ value }) => fleetRoles(record).includes(value))
    .map(({ label }) => label).join(' + ');
}

export function hasFleetWebAccess(organization) {
  if (organization?.status && organization.status !== 'active') return false;
  // Current responses use server-calculated capabilities; scalar fallback is for old responses only.
  if (organization?.capabilities) return organization.capabilities.fleetWeb === true;
  return organization?.accessLevel === 'fleet_manager';
}
